import api from "./axios";

export const getBranchUsersWithoutTime = async (branchId) => {
    const res = await api.get(
        `/branch-user_list/no-user-time/${branchId}`
    );

    return res.data?.branch_users || [];
};
export const getUserSchedule = async (branchUserId) => {
    const res = await api.get(`/user-time/${branchUserId}`);
    return res.data?.data || [];
};

export const getWeekDays = async () => {
    const res = await api.get("/week_days");
    return res.data?.days || [];
};

export const createUserTime = async (payload) => {
    return await api.post("/user-time", payload);
};
export const updateUserTime = async (id, payload) => {
    await api.put(`/user-time/${id}`, payload);
};
export const getMissingUserSchedule = async (branchUserId) => {
    const res = await api.get(
        `/user-time/missing/${branchUserId}`
    );

    // 🔥 MUHIM
    return res.data?.data || [];
};